<template>
  <div class="sidenav" :class="isNavBarClose ? 'none-mb' : 'mr2-mb expand'" @mouseover="onNavBarCollapse(true)" @mouseleave="onNavBarCollapse(false)">
    <div class="justify-between mt6 display-flex overflow-hidden content-box" @click.stop="onNavBarCollapse">
      <div class="display-flex justify-center flex-column">
        <!-- eslint-disable-next-line vue/no-use-v-if-with-v-for -->
        <div v-for="data in sidenavData" :key="data.title" class="bg-grey-hover">
          <div class="display-flex align-center pointer" v-if="hasPermission(data.roles)" @click="redirect(data.name)">
            <bh-icon :icon="data.icon" class="ma1 text-violet" :class="data.iconClass"/>
            <h3 class="f1-5 text-no-wrap ml2 w12 text-left text-violet h3 mr2 pt0-3">
              {{ data.title }}
            </h3>
          </div>
        </div>
      </div>
      <bh-icon v-if="!isNavBarClose" icon="arrow-left" class="hide-dk hide-tb bg-violet h3 w3 br50p pointer pos-rel ml--2 text-white pa0-3 mt2 f2 display-flex-mb left--1" @output.stop="onNavBarCollapse(false)"/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { User } from '@/services/user'

export default {
  name: 'bh-sidenav',
  data() {
    return {
      sidenavData: [
        {
          title: 'Dashboard',
          name: 'Dashboard',
          icon: 'dashboard',
          iconClass: 'f3'
        },
        {
          title: 'Performance',
          name: 'Performance',
          icon: 'speedometer',
          roles: ['admin', 'user'],
          iconClass: 'f2-3'
        },
        {
          title: 'Algo-Configuration',
          name: 'Configurations',
          icon: 'wrench',
          roles: ['admin', 'user'],
          iconClass: 'f3'
        },
        {
          title: 'AI-Configurations',
          name: 'AIConfigurations',
          icon: 'wrench',
          roles: ['admin', 'user'],
          iconClass: 'f3'
        },
        {
          title: 'Device Management',
          name: 'DeployedDeviceHistory',
          icon: 'wrench',
          roles: ['admin', 'user'],
          iconClass: 'f3'
        },
        {
          title: 'Settings',
          name: 'Settings',
          icon: 'user',
          roles: ['admin'],
          iconClass: 'f3 pl0-3'
        }
      ]
    }
  },
  computed: {
    ...mapGetters('device', ['customDateSet']),
    ...mapGetters('common/user', ['roles']),
    ...mapGetters(['isNavBarClose'])
  },
  methods: {
    ...mapActions(['setNavBarOpenStatus']),
    ...mapActions(['setLoader']),
    ...mapActions('device', ['setSingleProperty']),
    onNavBarCollapse(e) {
      this.setNavBarOpenStatus(!e)
    },
    redirect(name) {
      if (this.$route.name !== name) {
        this.setLoader(true)
        this.$router.push({ name })
      }
      this.setSingleProperty(['customDateSet', false])
    },
    hasPermission(permissionRoles) {
      if (!permissionRoles || !permissionRoles.length) {
        return true
      }
      return User.hasPermission(permissionRoles, this.roles)
    }
  }
}
</script>

<style scoped>
.sidenav {
  box-shadow: 0px 3px 6px #00000029;
  min-height: 100vh;
  top: 0;
  z-index: 1000;
  padding-top: 7rem;
  background-color: white;
  width: 5rem;
  transition: ease all 0.3s;
}

.expand {
  width: 25rem;
}
</style>
